// Copyright 2025, University of Maryland, All Rights Reserved
/**
 * Decision Gate processing node registration.
 */
import { registerPipelineNode } from '../../../core/pipeline-registry'
import { DecisionGateAdminView } from './components/AdminView'
import { DecisionGateWorkflowNode } from './components/WorkflowNode'

registerPipelineNode({
  id: 'processing.decision-gate',
  manifest: {
    id: 'processing.decision-gate',
    name: 'Decision Gate',
    category: 'processing',
    icon: 'GitCompare',
    description: 'Filter records based on upstream analysis results',
    order: 15,
  },
  WorkflowNode: DecisionGateWorkflowNode,
  AdminConfig: DecisionGateAdminView,
})
